import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent, ModalButton, ModalVariant } from '../modal/modal.component';

/**
 * Reusable Confirmation Modal Component (wraps the global app-modal)
 *
 * @example
 * // Basic usage
 * <app-confirmation-modal
 *   [isOpen]="showModal"
 *   [title]="'Confirm Logout'"
 *   [message]="'Are you sure you want to logout?'"
 *   [confirmText]="'Logout'"
 *   [cancelText]="'Cancel'"
 *   (confirm)="handleConfirm()"
 *   (cancel)="handleCancel()"
 * ></app-confirmation-modal>
 */
@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.css',
})
export class ConfirmationModalComponent implements OnInit, OnChanges {
  @Input() isOpen: boolean = false;
  @Input() variant: ModalVariant = 'default';
  @Input() title: string = 'Confirm Action';
  @Input() message: string = 'Are you sure you want to proceed?';
  @Input() errorMessage: string = '';
  @Input() confirmText: string = 'Confirm';
  @Input() cancelText: string = 'Cancel';
  @Input() confirmButtonClass: string = 'btn-error';
  @Input() cancelButtonClass: string = 'btn-secondary';
  @Input() isLoading: boolean = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  footerButtons: ModalButton[] = [];

  ngOnInit(): void {
    this.updateButtons();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateButtons();
  }

  private updateButtons(): void {
    this.footerButtons = [
      { label: this.cancelText, class: this.cancelButtonClass, disabled: this.isLoading, action: () => this.onCancel() },
      { label: this.isLoading ? 'Processing...' : this.confirmText, class: this.confirmButtonClass, loading: this.isLoading, disabled: this.isLoading, action: () => this.onConfirm() },
    ];
  }

  onConfirm(): void {
    if (this.isLoading) return;
    this.confirm.emit();
  }

  onCancel(): void {
    if (this.isLoading) return;
    this.cancel.emit();
  }
}
